var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-dropdown",style:({ width: _vm.dropdownlistWidth })},[_c('div',{staticStyle:{"padding":"10px 0"}},[_c('el-scrollbar',{ref:"clickselect",class:{'entTypeWrap':_vm.field=='enttype'||_vm.field=='entstatus'},attrs:{"wrap-class":"clickselect-scroll_wrap"}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f99e668","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/loader.js!./src/components/clickSelect/generalSelect.vue
// module id = a8EA
// module chunks = 30